export default function() {
  const widgetName = 'cardWidgetSpecialFeature';
  const widgetOpts = cardWidgetSpecialFeatureOpts;
  let maxVisible = 2;

  if ($('body').hasClass('eventsMode')) {
    maxVisible = 3;
    $(`#${widgetName}`).addClass('events-mode-active');
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const items = data.items;

      if (items.length === 3 && maxVisible === 3) {
        $(`#${widgetName}`).addClass('three-items');
      }

      $(`#${widgetName} .card-widget-item`).each(function(i) {
        const date = items[i].DateRange;
        $(this).find('.image-container').wrap('<div class="image-wrapper"><div class="image-wrapper-inner"></div></div>');
        if (date) {
          let startDate = date.slice(0, 7).replace(',','');
          let monthName = startDate.substring(0, 3).trim();
          let dayNum = startDate.slice(-2);
          if (dayNum.charAt(0) === "0") {
            dayNum = dayNum.slice(1);
          }
          $(this).find('.card-widget-title, .buttonwrap').wrapAll('<div></div>');
          $(this).find('.card-content').prepend(`<div class="card-widget-date"><span>${monthName}</span>${dayNum}</div>`);
        } else {
          $(this).find('.card-content').addClass('no-date');
        }
      });
      $(`#${widgetName} .buttonwrap a`).addClass('button');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: maxVisible,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}